import { Box, BoxProps } from "@chakra-ui/react";
import { FunctionComponent } from "react";

type Props = { html: string } & BoxProps;

function htmlWithLinksOpenInNewTab(html: string): string {
  const doc = new DOMParser().parseFromString(html, "text/html");
  doc.querySelectorAll("a[href]").forEach((a) => {
    if (!a.hasAttribute("target")) {
      a.setAttribute("target", "_blank");
    }
    if (!a.hasAttribute("rel")) {
      a.setAttribute("rel", "noopener noreferrer");
    }
  });
  return doc.documentElement.innerHTML;
}

export const RawHtmlViewer: FunctionComponent<Props> = (props) => {
  const { html, ...rest } = props;
  return <Box as="iframe" srcDoc={htmlWithLinksOpenInNewTab(html)} {...rest} />;
};
